import { DispatcherRepository } from '../repositories/dispatcher.repository'
import {
    ChangeDeliveryDatePayloadT,
    ChangeOrderTakeDate,
    DispactherGetTakeOrderResponseT,
    DispatcherAutoAssignPayloadT,
    DispatcherGetCouriersReportsResponseT,
    DispatcherGetDeliveredInvoicesFileResponseT,
    DispatcherGetDeliveriesListResponseT,
    DispatcherGetOrdersWithoutAddressResponseT,
    DispatcherGetStatusesDeliveryListResponseT,
    DispatcherGetStatusesListResponseT,
    DispatcherGetTakeOrdersParamsConfigT,
    DispatcherGetTakeOrdersResponseT,
    DispatcherGetTakesListResponseT,
    DispatcherGetWaitListStatusesResponseT,
    DispatcherOrdersWithoutAddressParamsT,
    DispatcherOrderWithoutAddressT,
    DispatcherSetOrderPayloadT,
    DispatcherSubmitCheckedOrdersPayloadT,
    DispatcherSubmitOrdersToDispatcherSectorPayloadT,
    DispatcherSubmitOrdersToSectorPayloadT,
    DispatcherSubmitOrderToCourierPayloadT,
    ListsParamsT,
} from '../types/dispatcher.types'

const dispatcherRepository = new DispatcherRepository()

export class DispatcherService {
    async getTakeOrders(
        dispatcher_sector_id: number,
        config: DispatcherGetTakeOrdersParamsConfigT
    ): Promise<DispatcherGetTakeOrdersResponseT> {
        const response = await dispatcherRepository.getTakeOrders(dispatcher_sector_id, config)
        return response.data
    }

    async getTakeOrder(order_id: number): Promise<DispactherGetTakeOrderResponseT> {
        const response = await dispatcherRepository.getTakeOrder(order_id)
        return response.data
    }

    async getStatuses(): Promise<DispatcherGetStatusesListResponseT> {
        const response = await dispatcherRepository.getStatuses()
        return response.data
    }

    async getStatusesDelivery(): Promise<DispatcherGetStatusesDeliveryListResponseT> {
        const response = await dispatcherRepository.getStatusesDelivery()
        return response.data
    }

    async getOrdersWithoutAddress(
        params: DispatcherOrdersWithoutAddressParamsT
    ): Promise<DispatcherGetOrdersWithoutAddressResponseT> {
        const response = await dispatcherRepository.getOrdersWithoutAddress(params)
        return response.data
    }

    async setOrderAddress(sender_id: number, payload: DispatcherSetOrderPayloadT): Promise<void> {
        await dispatcherRepository.setOrderAddress(sender_id, payload)
    }

    async submitOrdersToDispatcherSector(
        payload: DispatcherSubmitOrdersToDispatcherSectorPayloadT
    ): Promise<void> {
        await dispatcherRepository.submitOrdersToDispatcherSector(payload)
    }

    async submitOrdersToSector(payload: DispatcherSubmitOrdersToSectorPayloadT): Promise<void> {
        await dispatcherRepository.submitOrdersToSector(payload)
    }

    async submitOrderToCourier(payload: DispatcherSubmitOrderToCourierPayloadT): Promise<void> {
        await dispatcherRepository.submitOrderToCourier(payload)
    }

    async submitCheckedOrders(payload: DispatcherSubmitCheckedOrdersPayloadT): Promise<void> {
        await dispatcherRepository.submitCheckedOrders(payload)
    }

    async changeOrderTakeDate(payload: ChangeOrderTakeDate): Promise<void> {
        await dispatcherRepository.changeOrderTakeDate(payload)
    }

    async changeOrderDeliveryDate(payload: ChangeDeliveryDatePayloadT): Promise<void> {
        await dispatcherRepository.changeOrderDeliveryDate(payload)
    }

    async getTakesList(params: ListsParamsT): Promise<DispatcherGetTakesListResponseT> {
        const response = await dispatcherRepository.getTakesList(params)
        return response.data
    }

    async deleteTake(take_id: number): Promise<void> {
        const response = await dispatcherRepository.deleteTake(take_id)
        return response.data
    }

    async getDeliveryList(params: ListsParamsT): Promise<DispatcherGetDeliveriesListResponseT> {
        const response = await dispatcherRepository.getDeliveryList(params)
        return response.data
    }

    async deleteDelivery(delivery_id: number): Promise<void> {
        const response = await dispatcherRepository.deleteDelivery(delivery_id)
        return response.data
    }

    async getDeliveredInvoicesFile(
        fromDate: string,
        toDate: string
    ): Promise<DispatcherGetDeliveredInvoicesFileResponseT> {
        const response = await dispatcherRepository.getDeliveredInvoicesFile(fromDate, toDate)
        return response.data
    }

    async approveDelivery(delivery_id: number, payload?: FormData): Promise<void> {
        const response = await dispatcherRepository.approveDelivery(delivery_id, payload)
        return response.data
    }

    async getCouriersReports(
        dispatchers_sector_id: number
    ): Promise<DispatcherGetCouriersReportsResponseT> {
        const response = await dispatcherRepository.getCouriersReports(dispatchers_sector_id)
        return response.data
    }

    async enableAutoAssign(payload: DispatcherAutoAssignPayloadT): Promise<void> {
        const response = await dispatcherRepository.enableAutoAssign(payload)
        return response.data
    }

    async closeDelivery(deliveryId: number): Promise<void> {
        const response = await dispatcherRepository.closeDelivery(deliveryId)
        return response.data
    }

    async disableAutoAssign(payload: DispatcherAutoAssignPayloadT): Promise<void> {
        const response = await dispatcherRepository.disableAutoAssign(payload)
        return response.data
    }

    async loadWaitListStatuses(type = 1): Promise<DispatcherGetWaitListStatusesResponseT> {
        const response = await dispatcherRepository.loadWaitListStatuses(type)
        return response.data
    }
}
